import { render, staticRenderFns } from "./ItemRegisterComponent.vue?vue&type=template&id=6772708d&scoped=true"
import script from "./ItemRegisterComponent.vue?vue&type=script&lang=js"
export * from "./ItemRegisterComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6772708d",
  null
  
)

export default component.exports